import { render, staticRenderFns } from "./RoundWinLoseBottom.vue?vue&type=template&id=f5373df0&scoped=true&"
import script from "./RoundWinLoseBottom.vue?vue&type=script&lang=js&"
export * from "./RoundWinLoseBottom.vue?vue&type=script&lang=js&"
import style0 from "./RoundWinLoseBottom.vue?vue&type=style&index=0&id=f5373df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5373df0",
  null
  
)

export default component.exports